<!-- src/components/common/Analytics.svelte -->
<script>
  import { onMount } from 'svelte';

  onMount(() => {
    // Add preconnect for the CDN domain
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://sitebehaviour-cdn.fra1.cdn.digitaloceanspaces.com';
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);

    // Delay script load until after the page is interactive
    // This prevents it from competing with critical rendering
    setTimeout(() => {
      const sb_site_secret = '4676e608-c3fc-42a3-8725-ee65ef2c6f5b';
      // @ts-ignore - Custom window property
      window.sitebehaviourTrackingSecret = sb_site_secret;
      const script_element = document.createElement('script');
      script_element.async = true;
      script_element.defer = true; // Add defer attribute
      script_element.id = 'site-behaviour-script-v2';
      script_element.src = 'https://sitebehaviour-cdn.fra1.cdn.digitaloceanspaces.com/index.min.js?sitebehaviour-secret=' + sb_site_secret;
      document.head.appendChild(script_element);
    }, 2000); // Delay by 2 seconds to prioritize LCP
  });
</script> 